<template>
  <div class="container mx-auto px-10 py-8 space-y-6">
    <div
      v-for="subscription in props.subscriptions"
      :key="subscription.Id"
      class="relative bg-white shadow-lg rounded-xl overflow-hidden transition-transform transform hover:scale-105 duration-300"
    >
      <div class="p-6 bg-gray-200 border-b">
        <div class="flex justify-between items-center">
          <div>
            <p class="text-xs uppercase text-gray-500">İlk Ödeme</p>
            <p class="text-lg font-bold text-gray-800">
              {{ formatDate(subscription.FirstStartAt) }}
            </p>
          </div>
          <div>
            <i class="fas fa-arrow-right text-3xl text-gray-800"></i>
          </div>
          <div>
            <p class="text-xs uppercase text-gray-500">Dönem Başlangıcı</p>
            <p class="text-lg font-bold text-gray-800">
              {{ formatDate(subscription.StartedAt) }}
            </p>
          </div>
          <div>
            <i class="fas fa-arrow-right text-3xl text-gray-800"></i>
          </div>
          <div>
            <p class="text-xs uppercase text-gray-500">Dönem Bitişi</p>
            <p
              class="text-lg font-bold"
              :class="
                getDaysLeft(subscription.ExpiresAt) <= 10
                  ? 'text-red-600'
                  : 'text-gray-800'
              "
            >
              {{ formatDate(subscription.ExpiresAt) }}
            </p>
          </div>
        </div>
        <div class="mt-2 text-sm font-medium">
          <span
            class="px-3 py-1 rounded-full"
            :class="getStatusClass(subscription.SubscriptionStatus)"
          >
            {{ getStatusText(subscription.SubscriptionStatus) }}
          </span>
        </div>
      </div>

      <div class="p-6 pt-0 pb-0">
        <ul class="divide-y divide-gray-200">
          <li
            v-for="order in subscription.Orders"
            :key="order.FeatureName + order.PackageName"
            class="py-4 flex justify-between"
          >
            <div>
              <p class="text-sm font-medium text-gray-800">
                {{ order.FeatureName || order.PackageName }}
              </p>
              <p class="text-xs text-gray-500">Miktar: {{ order.Quantity }}</p>
            </div>
            <p class="text-sm font-semibold text-gray-700">
              {{ order.TotalPrice.toFixed(2) }} ₺
            </p>
          </li>
        </ul>
      </div>

      <div class="p-6 bg-gray-50">
        <div class="grid grid-cols-2 gap-3">
          <!-- Süre Uzat Butonu - Her zaman görünür -->
          <button
            class="bg-blue-500 text-white py-2 rounded-lg font-medium hover:bg-blue-600 transition-all duration-200"
            @click="extendSubscription(subscription.Id)"
          >
            Süre Uzat
          </button>

          <!-- Panel Butonları -->
          <button
            v-if="subscription.Subdomain !== ''"
            class="py-2 px-1 rounded-lg font-medium transition-all duration-200"
            :disabled="
              ['IN_PROGRESS', 'PENDING', 'FAILED'].includes(
                panelStatusesEnums[subscription.Id]
              )
            "
            :class="
              ['IN_PROGRESS', 'PENDING', 'FAILED'].includes(
                panelStatusesEnums[subscription.Id]
              )
                ? 'bg-gray-200 text-gray-800'
                : 'bg-green-500 text-white hover:bg-green-600'
            "
            @click="gotoPanel(subscription.Subdomain)"
          >
            <span
              v-if="
                ['IN_PROGRESS', 'PENDING', 'FAILED'].includes(
                  panelStatusesEnums[subscription.Id]
                )
              "
            >
              <i class="fas fa-spinner fa-spin mr-1"></i>
            </span>
            {{ panelStatuses[subscription.Id] }}
          </button>

          <!-- Domain Seçimi Yap -->
          <button
            v-else
            class="bg-red-500 text-white py-2 rounded-lg font-medium hover:bg-red-600 transition-all duration-200"
            @click="selectDomain(subscription.Id)"
          >
            Özel adres Seçimi Yap
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getPanelStatus, createRenewalOrder } from "@/services/userServices";

const router = useRouter();
const props = defineProps(["subscriptions"]);
const panelStatuses = ref({});
const panelStatusesEnums = ref({});
const intervalId = ref(null);

onMounted(() => {
  getAllStatuses(true);

  intervalId.value = setInterval(getAllStatuses, 10000);
});

const getAllStatuses = async (isFirst = false) => {
  props.subscriptions.forEach((subscription) => {
    if (
      (panelStatusesEnums.value[subscription.Id] === "IN_PROGRESS" ||
        panelStatusesEnums.value[subscription.Id] === "PENDING" ||
        panelStatusesEnums.value[subscription.Id] === "FAILED") &&
      !isFirst
    ) {
      getPanelStatusText(subscription.Id);
    } else if (isFirst) {
      getPanelStatusText(subscription.Id);
    }
  });
};

const getStatusText = (status) => {
  if (status === 1) return "Aktif";
  if (status === 0) return "Deaktif";
  if (status === 3) return "Kapatılmış";
  return "Bilinmeyen";
};

const getPanelStatusText = async (subscriptionId) => {
  const response = await getPanelStatus(subscriptionId);

  if (response) {
    if (response.MigrationStatus === "SUCCESSFUL") {
      panelStatuses.value[subscriptionId] = "Panele Git";
    } else if (response.MigrationStatus === "PENDING") {
      panelStatuses.value[subscriptionId] = "Panel Bekliyor";
    } else if (response.MigrationStatus === "FAILED") {
      panelStatuses.value[subscriptionId] = "Panelde Hata Var";
    } else if (response.MigrationStatus === "IN_PROGRESS") {
      panelStatuses.value[subscriptionId] = "Panel Oluşturuluyor";
    } else {
      panelStatuses.value[subscriptionId] = "Bilinmeyen";
    }
    panelStatusesEnums.value[subscriptionId] = response.MigrationStatus;
  }
};

const getStatusClass = (status) => {
  if (status === 1) return "bg-green-500 text-white";
  if (status === 0) return "bg-yellow-500 text-white";
  if (status === 3) return "bg-red-500 text-white";
  return "bg-gray-500 text-white";
};

const formatDate = (date) => {
  return new Date(date).toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const getDaysLeft = (expiresAt) => {
  const now = new Date();
  const expirationDate = new Date(expiresAt);
  const diff = expirationDate - now;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

const extendSubscription = (id) => {
  createRenewalOrder(id)
    .then((response) => {
      const paymentUrl = response.Payload.PaymentUrl;
      if (paymentUrl) {
        window.open(paymentUrl, "_blank");
      }
    })
    .catch((error) => {
      console.error("Abonelik uzatma hatası:", error);
      alert("Abonelik süresi uzatılırken bir hata oluştu.");
    });
};

const gotoPanel = (subdomain) => {
  window.open(`https://${subdomain}.ymmofisim.tr`, "_blank");
};

const selectDomain = (id) => {
  router.push({
    name: "domain-selection",
    query: { subscriptionId: id },
  });
};
</script>
